var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Reset Password", body: "Reset your password here" } },
    [
      _c("ValidationObserver", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid, handleSubmit }) {
              return [
                _c("ValidationProvider", {
                  attrs: {
                    name: "current-password",
                    rules: "required|password_len",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors, touched }) {
                          return [
                            _c("FormGroup", {
                              attrs: {
                                type: "password",
                                title: "Current Password",
                                placeholder: "Enter password",
                                name: "curent",
                                errors: touched ? errors : [],
                              },
                              model: {
                                value: _vm.currentPassword,
                                callback: function ($$v) {
                                  _vm.currentPassword = $$v
                                },
                                expression: "currentPassword",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("ValidationProvider", {
                  attrs: {
                    name: "new-password",
                    rules: "required|password_len",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors, touched }) {
                          return [
                            _c("FormGroup", {
                              staticClass: "mt-6",
                              attrs: {
                                type: "password",
                                title: "New Password",
                                placeholder: "Enter new password",
                                name: "new",
                                errors: touched ? errors : [],
                              },
                              model: {
                                value: _vm.newPassword,
                                callback: function ($$v) {
                                  _vm.newPassword = $$v
                                },
                                expression: "newPassword",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("ValidationProvider", {
                  attrs: {
                    vid: "confirm",
                    name: "confirm-password",
                    rules: "required|password:@new-password",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors, touched }) {
                          return [
                            _c("FormGroup", {
                              staticClass: "mt-6",
                              attrs: {
                                type: "password",
                                title: "Confirm Password",
                                placeholder: "Confirm new password",
                                name: "confirm",
                                errors: touched ? errors : [],
                              },
                              model: {
                                value: _vm.confirmPassword,
                                callback: function ($$v) {
                                  _vm.confirmPassword = $$v
                                },
                                expression: "confirmPassword",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("UiButton", {
                  staticClass: "mt-3 flex justify-end",
                  attrs: {
                    buttonText: "Reset",
                    processing: _vm.processing,
                    disabled: invalid,
                  },
                  on: {
                    click: function ($event) {
                      return handleSubmit(_vm.resetPassword)
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }